var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "#02223C",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 9.33334C12.7623 9.33334 11.5753 9.82501 10.7001 10.7002C9.82498 11.5753 9.33331 12.7623 9.33331 14C9.33331 15.2377 9.82498 16.4247 10.7001 17.2998C11.5753 18.175 12.7623 18.6667 14 18.6667C15.2377 18.6667 16.4246 18.175 17.2998 17.2998C18.175 16.4247 18.6666 15.2377 18.6666 14C18.6666 12.7623 18.175 11.5753 17.2998 10.7002C16.4246 9.82501 15.2377 9.33334 14 9.33334Z",
    fill: "#02223C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 0C6.17218 0 4.03561 0.884998 2.4603 2.4603C0.884998 4.03561 0 6.17218 0 8.4L0 19.6C0 21.8278 0.884998 23.9644 2.4603 25.5397C4.03561 27.115 6.17218 28 8.4 28H19.6C21.8278 28 23.9644 27.115 25.5397 25.5397C27.115 23.9644 28 21.8278 28 19.6V8.4C28 6.17218 27.115 4.03561 25.5397 2.4603C23.9644 0.884998 21.8278 0 19.6 0L8.4 0ZM7.46667 14C7.46667 12.2673 8.155 10.6055 9.38024 9.38024C10.6055 8.155 12.2673 7.46667 14 7.46667C15.7327 7.46667 17.3945 8.155 18.6198 9.38024C19.845 10.6055 20.5333 12.2673 20.5333 14C20.5333 15.7327 19.845 17.3945 18.6198 18.6198C17.3945 19.845 15.7327 20.5333 14 20.5333C12.2673 20.5333 10.6055 19.845 9.38024 18.6198C8.155 17.3945 7.46667 15.7327 7.46667 14V14ZM20.5333 7.46667H22.4V5.6H20.5333V7.46667Z",
    fill: "#02223C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.c7fcf33bfeae092d327f12cac22c01ea.svg";
export { ForwardRef as ReactComponent };